export const DAKTELA_ORDER_FEED_JOB = 'daktela-order-feed'
export const DAKTELA_ORDER_FEED_COLLECTION = 'daktela_order_feed'
export const DAKTELA_ORDER_FEED_DEFAULT_CRON = '0 7 3 * * *'
export const DAKTELA_ORDER_FEED_TIME_ZONE = 'Europe/Prague'

export interface OrderFeedDispatch {
  period: string
  age: string
  series: string
  number: string
  stock: string
  quantity: number
  unit: string
  cancelled: boolean
}

export interface OrderFeedSourceItem {
  id: string
  materialId: string
  quantity: number
  unit: string
  unsupportedReason?: string
  dispatches: OrderFeedDispatch[]
}

export interface OrderFeedSourceOrder {
  series: string
  number: string
  externalNumber: string
  unsupportedReason?: string
  items: OrderFeedSourceItem[]
}

export interface OrderFeedSourcePage {
  schemaVersion: 1
  items: OrderFeedSourceOrder[]
  hasMore: boolean
}

export type OrderFeedStatus = 'READY_FOR_DISPATCH' | 'PARTIALLY_READY' | 'IN_PROGRESS' | 'UNKNOWN'

export const ORDER_FEED_STATUS_DESCRIPTIONS: Record<OrderFeedStatus, { label: string; description: string }> = {
  READY_FOR_DISPATCH: {
    label: 'Připraveno k expedici',
    description: 'Celé objednané množství prošlo finální skladovou kontrolou. Nejde o potvrzení předání dopravci.',
  },
  PARTIALLY_READY: {
    label: 'Částečně připraveno',
    description: 'Finální kontrolou prošla pouze část objednaného množství.',
  },
  IN_PROGRESS: {
    label: 'Příprava probíhá',
    description: 'Je doložen rozpracovaný výdej nebo čekání na finální kontrolu, ale dosud žádné dokončené množství.',
  },
  UNKNOWN: {
    label: 'Stav nelze ověřit',
    description: 'Chybí jednoznačná vazba nebo dostatečná data. Neznamená to automaticky neodeslanou objednávku.',
  },
}

export interface DaktelaOrderFeedState {
  _id: string
  runSync?: boolean
  cronTime?: string
  runId?: string
  startedAt?: Date
  leaseUntil?: Date
  lastAttemptAt?: Date
  lastSuccessAt?: Date
  lastError?: string
  lastErrorDetails?: string
  xmlContent?: string
  generatedAt?: Date
  sourceSyncedAt?: Date
  selectionFrom?: Date
  selectionTo?: Date
  orderCount?: number
  unknownCount?: number
  sizeBytes?: number
  durationMs?: number
}
